export default {
    MilitantesProximos: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "militantes-proximos"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/MilitantesProximos.js
// module id = cHMD
// module chunks = 16